import { useState } from "react";
import { useFilter } from "./FilterContext.js";
import styles from "./Filter.module.css";
import Dropdown from "../Dropdown/Dropdown.js";
import { useTranslation } from "react-i18next";
import StatusMessage from "../StatusMessage/StatusMessage.js";

// leading: 검색 줄 맨 앞에 넣을 요소 (예: 원작대 경기 날짜)
const Filter = ({
  onSearch,
  leading,
  showGroupName = false,
  showGender = false,
  showAttendance = false,
}) => {
  const { t } = useTranslation();
  const { countries, loading, error } = useFilter();

  const [filters, setFilters] = useState({
    country: "",
    groupName: "",
    playerName: "",
    genderLabel: "",
    attendanceLabel: "",
  });

  const handleInputChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleSearch = () => {
    onSearch(filters);
  };

  // 국가 목록을 불러오는 동안은 검색 줄을 잠깐 비워 둠
  if (loading) return null;
  if (error) return <StatusMessage type="error" description={error} />;

  return (
    <div className={styles.filter}>
      {leading}
      <Dropdown
        key={t("filter.search-by-country")}
        props={{
          data: [t("filter.search-by-country"), ...countries],
          onChange: (value) =>
            handleInputChange(
              "country",
              value === t("filter.search-by-country") ? "" : value
            ),
        }}
      />
      {showGroupName && (
        <input
          type="text"
          placeholder={t("filter.team-name")} // 단체명
          value={filters.groupName}
          onChange={(e) => handleInputChange("groupName", e.target.value)}
        />
      )}
      <input
        type="text"
        placeholder={t("filter.player-name")}
        value={filters.playerName}
        onChange={(e) => handleInputChange("playerName", e.target.value)}
      />
      {showGender && (
        <Dropdown
          key={t("common.gender")}
          props={{
            data: [t("common.gender"), t("common.m"), t("common.f")],
            onChange: (value) =>
              handleInputChange(
                "genderLabel",
                value === t("common.gender") ? "" : value
              ),
          }}
        />
      )}
      {showAttendance && (
        <Dropdown
          key={t("filter.status")}
          props={{
            data: [t("filter.status"), "O", "X"],
            onChange: (value) =>
              handleInputChange(
                "attendanceLabel",
                value === "Status" ? "" : value
              ),
          }}
        />
      )}
      <button className={styles.searchButton} onClick={handleSearch}>
        {t("filter.search")}
      </button>
    </div>
  );
};
export default Filter;
